import React from "react";

import "./style.css";

const Error = () => {
  return <div className="error--message">An error has occurred!!!!!!!!!.</div>;
};

export default Error;
